import React from 'react';
import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '../components/Typography';
import BottomNav from './components/BottomNav';
import FooterSection from './components/FooterSection';
import { footerMenu } from './helpers';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        type: 'dark',
        text: {
            primary: '#EFEFEF'
        },
        secondary: {
            main: '#222',
        }
    },
    typography: {
        fontFamily: 'Lato, sans-serif',
        useNextVariants: true
    },
});

const styles = theme => ({
    banner: {
        backgroundColor: '#D4002A',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        height: 160,
        marginBottom: -90,
        marginRight: '10%',
        paddingLeft: '10%',
        zIndex: 1,
        maxWidth: 1000,
        position: 'relative',
        boxShadow: theme.shadows[15]
    },
    bannerItem: {
        marginLeft: '2rem',
        marginRight: '2rem',
        flexGrow: 1,
        minWidth: 230,
        textAlign: 'center',
    },
    bannerText: {
        color: 'white',
        width: '100%',
        textAlign: 'center'
    },
    button: {
        fontWeight: 'bold',
        '&:hover': {
            boxShadow: theme.shadows[15],
            color: 'white'
        }
    },
    footer: {
      backgroundColor: '#222',
      padding: '100px 5% 20px',
    },
    footerMenu: {
        display: 'flex',
        justifyContent: 'space-between'
    },
});
  
class Footer extends React.Component {
    render() {
        const { classes } = this.props;
    
        return (
            <MuiThemeProvider theme={theme}>
                <React.Fragment>
                    <div>  
                        <div className={classes.banner}>
                            <div className={classes.bannerItem}>
                                <Typography bold={true} className={classes.bannerText} variant='h5'>Not A Member Yet?<br/><br/>Join DirectBuy Today</Typography>
                            </div>
                            <div className={classes.bannerItem}>
                                <Button component='a' color='secondary' variant='contained' size='large' href='/v2/membership-pricing/' className={classes.button}>Become a Member</Button>
                            </div>
                        </div>
                    </div>
                    <footer className={classes.footer}>
                        <Hidden smDown>
                            <div className={classes.footerMenu}>
                                {footerMenu.map((props, i) => <div key={i} style={{width: '100%', display: 'flex', justifyContent: 'center'}}><FooterSection {...props}/></div>)}
                            </div>
                            <Divider style={{height: 2}}/>
                        </Hidden>
                        <BottomNav/>
                    </footer>
                </React.Fragment>
            </MuiThemeProvider>
        );
    }
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
